import {
  Box,
  ButtonNew,
  ColorOptions,
  convertHexToRGBA,
  Icon,
  IconButton,
  ModalDialogNew,
  ModBox,
  Spacer,
  Text
} from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { Dimensions } from 'react-native'
import { DownloadFileModal } from '../../comps/DownloadFileModal'
import { HeaderLeft } from '../../comps/MobileCustomHeader/HeaderLeft'
import { SvgImage } from '../../comps/SvgImage'
import { useLazyApiData, useStores } from '../../data/store'
import { DeviceShare, openFileOnDevice } from '../../util/permissions'
import {
  Colors,
  dateFormatter,
  DateFormatTypes,
  DOWNLOAD_FAILED,
  FILE_DOWNLOADED,
  fromDateTime,
  hasPermissions,
  toDateTime
} from '../../util/util'
import { Downloads } from '../Payments/Downloads'
import { Platform } from 'react-native'
import FileViewer from 'react-native-file-viewer';

const SettlementDetails = ({ route }: any) => {
  const { settlementDatails } = route?.params
  const {
    mid,
    setMessage,
    settlementAccount,
    generateSettlementFile,
    settlementFileDownload,
    toastMessage,
    toastResetMessage,
    canExportSettlementsReport,
  } = useStores((store) => ({
    mid: store.user.selectedMid,
    setMessage: store.response.setMessage,
    settlementAccount: store.user.settlementAccount,
    generateSettlementFile: store.settlements.generateSettlementFile,
    settlementFileDownload: store.settlements.settlementFileDownload,
    toastMessage: store?.reports?.getMessage(),
    toastResetMessage: store?.reports?.resetMessage,
    canExportSettlementsReport: store.userManagement.isSettlementExportEnabled(),
  }))
  const [generateSettlemFile, { state: generateFileState }] = useLazyApiData(generateSettlementFile)
  const [setlmentFileDwnld, { state, data: setlmentFileDwnldApiData }] = useLazyApiData(settlementFileDownload)
  const [showDownloadSuccessModal, setShowDownloadSuccessModal] = useState(false)
  const [showDownloadInfoVisible, setShowDownloadInfoVisible] = useState(false)
  const [showDownloadReportsVisible, setShowDownloadReportsVisible] = useState(false)
  const navigation = useNavigation()

  useEffect(() => {
    if (toastMessage?.length > 0 && showDownloadInfoVisible) {
      setTimeout(() => {
        toastResetMessage()
        setShowDownloadInfoVisible(false)
      }, 5000)
    }
  }, [toastMessage, showDownloadInfoVisible])

  const headerLeft = () => {
    return (
      <Box backgroundColor={'TRANSPARENT'} flexDirection="row" justifyContent="center" alignItems={'center'} h={64}>
        <ModBox
          paddingLeft={25}
          paddingRight={10}
          top={ Platform.OS === 'ios' ? -30 : 0 }
          show={navigation?.canGoBack()}
          underlayColor={'TRANSPARENT'}
          testID="back-arrow"
          onPress={() => navigation?.goBack()}>
          <SvgImage imageName="HeaderArrowLeft" />
        </ModBox>
      </Box>
    )
  }

  useEffect(() => {
    navigation?.setOptions({
      title: '',
      headerTintColor: '#000',
      headerBackVisible: true,
      headerLeft:Platform.OS === 'ios' ? headerLeft : () => <HeaderLeft />,
      headerStyle: {
         backgroundColor: Colors.SECONDARY,
        top: Platform.OS === 'ios' ? -30 : 0,
      },
    })
  }, [])

  useEffect(() => {
    if (state === 'fulfilled') {
      if (setlmentFileDwnldApiData?.code === FILE_DOWNLOADED || setlmentFileDwnldApiData?.code === DOWNLOAD_FAILED) {
        setShowDownloadSuccessModal(true)
      } else {
        setShowDownloadInfoVisible(toastMessage?.length > 0)
      }
    }
  }, [state])
  useEffect(() => {
    if (generateFileState === 'rejected' || generateFileState === 'fulfilled') {
      const dateArr = settlementDatails?.date?.split('-')
      const settlmtDate = new Date(dateArr[2], dateArr[1] - 1, dateArr[0])
      const fromDate = `${fromDateTime(settlmtDate)}`
      const toDate = `${toDateTime(settlmtDate, false, true)}`
      setlmentFileDwnld(
        mid,
        settlementDatails?.id,
        settlementDatails?.fileName,
        setlmentFileDwnld,
        'XLSX',
        fromDate,
        toDate,
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generateFileState, setlmentFileDwnld])

  const getDetails = () => {
    const settlement = {
      value: settlementAccount,
      key: 'Bank Account',
    }
    const dataset = [
      {
        value: settlementDatails?.referenceNumber,
        key: 'CMS Number',
      },
      {
        value: dateFormatter(settlementDatails?.date, DateFormatTypes.DD_MMM_YYYY),
        key: 'Date & Time',
      },
    ]
    if (settlementAccount && settlementAccount !== 'NA') {
      dataset.unshift(settlement)
    }

    return dataset
  }

  const details = getDetails()

  const checkPermissionAndGenerate = async () => {
    if (generateFileState !== 'pending') {
      hasPermissions().then((value) => {
        if (value) {
          generateSettlemFile('Excel', true, settlementDatails?.date)
        } else {
          setMessage('Permissions not granted')
        }
      })
    }
  }

  const share = async (path: any) => {
    // setShowDownloadSuccessModal(false)
    try {
      const shareOptions = {
        url: `file://'${path}`,
      }
      await DeviceShare(shareOptions)
      // setShowDownloadSuccessModal(false)
    } catch (error) {
      console.log(error)
      setShowDownloadSuccessModal(false)
    }
  }

  const openFile = async () => {
    if (setlmentFileDwnldApiData?.code === 1 && !isEmpty(setlmentFileDwnldApiData?.filepath)) {

      if (Platform.OS === 'ios')
      {
        FileViewer.open(setlmentFileDwnldApiData?.filepath)
        .then(() => {
          // success
          // setShowDownloadSuccessModal(false)
        })
        .catch(_err => {
          // error
          console.log(_err)
          setShowDownloadSuccessModal(false)
        });
      }
      else
      {
          try {
          openFileOnDevice(setlmentFileDwnldApiData?.filepath)
          setShowDownloadSuccessModal(false)
          } catch (err) {
            console.log(err)
            setShowDownloadSuccessModal(false)
          }
      }
    } else {
      const dateArr = settlementDatails?.date?.split('-')
      const settlmtDate = new Date(dateArr[2], dateArr[1] - 1, dateArr[0])
      const fromDate = `${fromDateTime(settlmtDate)}`
      const toDate = `${toDateTime(settlmtDate)}`
      setlmentFileDwnld(
        mid,
        settlementDatails?.id,
        settlementDatails?.fileName,
        setlmentFileDwnld,
        'XLSX',
        fromDate,
        toDate,
      )
    }
  }

  const h = Dimensions.get('screen').height
  return (
    <Box backgroundColor={'SECONDARY'} flex={1}>
      <Box p={24} borderTopLeftRadius={24} borderTopRightRadius={24} zIndex={1} bg={'WHITE'} f={1}>
        <SvgImage color={Colors.PRIMARY} imageName="bizzLogo" />
        <Spacer direction="vertical" size={16} />
        <Text
          title={'Settlement from JioPay Business'}
          fontFamily={'JioType-Bold'}
          fontSize={16}
          lineHeight={24}
          letterSpacing={-0.08}
        />
        <Spacer direction="vertical" size={2} />
        <Text
          title={dateFormatter(settlementDatails?.date, DateFormatTypes.DD_MMM_YYYY)}
          fontFamily={'JioType-Medium'}
          fontSize={14}
          lineHeight={24}
          letterSpacing={-0.08}
          color={convertHexToRGBA(Colors.BLACK, 65) as ColorOptions}
        />
        <Spacer direction="vertical" size={8} />
        <Text
          title={settlementDatails?.settlementAmount}
          fontFamily={'JioType-Black'}
          fontSize={32}
          lineHeight={36}
          letterSpacing={-0.08}
        />
        <Spacer direction="vertical" size={42} />
        <Box flexDirection={'row'}>
          <Icon id={'ROUND_TICK_FILLED'} color={'GREEN'} size={20} />
          <Spacer direction="horizontal" size={16} />
          <Text
            title={'Settlement created'}
            fontFamily={'JioType-Medium'}
            fontSize={14}
            lineHeight={20}
            letterSpacing={-0.07}
            color={'BLACK'}
          />
        </Box>
        <ModBox show={!isEmpty(settlementDatails?.referenceNumber)} h={18} w={'1'} ml={9} bg={'GREEN'} />
        <ModBox flexDirection={'row'} show={!isEmpty(settlementDatails?.referenceNumber)}>
          <Icon id={'ROUND_TICK_FILLED'} color={'GREEN'} size={20} />
          <Spacer direction="horizontal" size={16} />
          <Text
            title={'Payments settled'}
            fontFamily={'JioType-Medium'}
            fontSize={14}
            lineHeight={20}
            letterSpacing={-0.07}
            color={'BLACK'}
          />
        </ModBox>
        <Spacer direction="vertical" size={42} />
        <Box borderWidth={1} borderRadius={8} borderColor={Colors.DISABLED_GREY as ColorOptions} p={16}>
          {details?.map((item, index) => (
            <Box flexDirection={'row'} align={'center'} justify={'space-between'}>
              <Box flex={0.4}>
                <Text
                  fontWeight={'600'}
                  color={'#757575' as ColorOptions}
                  fontSize={14}
                  numberOfLines={1}
                  fontFamily={'JioType-Medium'}
                  lineHeight={26}
                  letterSpacing={-0.07}>
                  {item.key}
                </Text>
              </Box>
              <Spacer size={16} direction={'vertical'} />
              <Box flex={0.6} align={'flex-start'}>
                <Text fontSize={14} selectable fontFamily="JioType-Medium" color={'BLACK'} textAlign={'left'}>
                  {item?.value !== 'undefined' ? String(item?.value ?? 'NA') : 'NA'}
                </Text>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      <ModBox bg={'WHITE'} p={24} show={canExportSettlementsReport}>
        <ButtonNew
          title={'Download Report'}
          onPress={checkPermissionAndGenerate}
          borderColor={'PRIMARY'}
          isRaceTrack
          borderRadius={24}
          type={'secondary'}
          titleColor={'PRIMARY'}
          isLoading={generateFileState === 'pending' || state === 'pending'}
          loadingColor={'PRIMARY'}
        />
      </ModBox>
      {showDownloadInfoVisible && (
        <Box
          position={'absolute'}
          zIndex={10}
          bg={'BLACK'}
          pv={16}
          ph={20}
          left={0}
          right={0}
          bottom={0}
          flexDirection={'row'}
          align={'center'}
          justify={'space-between'}>
          <Box f={1}>
            <Text
              title={toastMessage}
              color={'WHITE'}
              fontSize={12}
              fontFamily={'JioType-Medium'}
              lineHeight={16}
              letterSpacing={-0.06}
            />
          </Box>
          <Spacer size={8} direction='horizontal' />
          <Box>
            <Text
              title={'View Report'}
              color={'PRIMARY'}
              fontSize={12}
              fontFamily={'JioType-Medium'}
              lineHeight={16}
              letterSpacing={-0.06}
              testID="view-report"
              onPress={() => setShowDownloadReportsVisible(true)}
            />
          </Box>
        </Box>
      )}
      {showDownloadSuccessModal && (
        <ModalDialogNew animate={true} show={showDownloadSuccessModal} type={'bottom'} backgroundColor="TRANSPARENT">
          <Box bg={'WHITE'} borderTopLeftRadius={24} borderTopRightRadius={24}>
            <DownloadFileModal
              status={setlmentFileDwnldApiData?.code}
              onPress={() => openFile()}
              onShare={() => share(setlmentFileDwnldApiData?.filepath)}
              close={() => setShowDownloadSuccessModal(false)}
            />
          </Box>
        </ModalDialogNew>
      )}
      {showDownloadReportsVisible && (
        <ModalDialogNew
          show={showDownloadReportsVisible}
          type={'bottom'}
          backgroundColor={'TRANSPARENT'}
          animate={true}
          borderRadius={24}>
          <Box bg={'WHITE'} h={h - 118} borderTopRightRadius={24} borderTopLeftRadius={24} pv={32}>
            <Box flexDirection={'row'} align={'center'} justify={'space-between'} ph={24}>
              <Text
                title={'Transaction Statements'}
                fontFamily={'JioType-Black'}
                color={Colors.BLACK_14 as ColorOptions}
                fontSize={24}
                lineHeight={32}
                letterSpacing={-0.09}
              />
              <IconButton
                id={'CLOSE'}
                color={Colors.BLACK_14 as ColorOptions}
                size={24}
                testID="close-settle"
                onPress={() => setShowDownloadReportsVisible(false)}
              />
            </Box>
            <Spacer direction={'vertical'} size={16} />
            <Downloads isSettlements={true} />
          </Box>
        </ModalDialogNew>
      )}
    </Box>
  )
}

export default SettlementDetails
